import React, { useState } from 'react';
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { Form, Input, Label, Row, Col, Button, CardBody } from 'reactstrap';
import Axios from "axios";

import LoadScreen from "../../UI/LoadScreen";

const TestLoginForm = () => {
    const { register, handleSubmit, formState: { errors } } = useForm();
    const [isDataLoading, setIsDataLoading] = useState(false)
    const navigate = useNavigate();
    const onSubmit = (data) => {
        setIsDataLoading(true)
        // const dataForm = {
        //     email: emailRef.current.value,
        //     password: passwordRef.current.value
        // }
        async function postLogin() {
            const response = await Axios.get('api/login/basic-token')
            const tResponse = await Axios.post('/api/login', data
                , {
                    headers: {
                        'Content-Type': 'application/json;charset=utf-8',
                        Authorization: "Bearer " + response.data.token,
                    }
                }).catch((error) => {
                    console.log(error)
                    alert('Ошибка авторизации')
                }
                ).then(
                    setIsDataLoading(false)
                )

            sessionStorage.setItem('token', tResponse.data.Token);
            sessionStorage.setItem('tokenExpiresIn', tResponse.data.ExpiresIn);
            sessionStorage.setItem('role', tResponse.data.Role)
            localStorage.setItem('refreshToken', tResponse.data.RefreshToken)
            localStorage.setItem('refreshTokenExpiresIn', tResponse.data.RefreshExpiresIn)
            if (tResponse.status == 200 && sessionStorage.getItem('token') != null) {

                const returnUrl = sessionStorage.getItem("returnUrl")
                if (returnUrl) {
                    sessionStorage.clear("returnUrl")
                    window.location.href = returnUrl;
                    return navigate(returnUrl)
                }
                window.location.href = "/";
            }
        }
        postLogin()

    };
    // console.log(errors);

    return (
        <div>
            {isDataLoading ? <LoadScreen className="m-5"></LoadScreen> :
                <CardBody className="py-5 px-md-5">
                    <Row className="d-flex justify-content-center">
                        <Col md="6">
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <div className='form-outline mb-2'>
                                    <label htmlFor='email' className="form-label">E-Mail</label>
                                    <input type="string" className='form-control' id='email' placeholder='mail@leningradcenter.ru' {...register("email", { required: { value: true, message: "Поле \"E-Mail\" не может быть пустым" }, pattern: { value: /^\S+@\S+$/i, message: "Некорректно указан E-Mail" } })} />
                                    {errors.email && <span className='text-danger'>{errors.email?.message}</span>}
                                </div>
                                <div className='form-outline mb-2'>
                                    <label htmlFor='password' className="form-label">E-Mail</label>
                                    <input type="password" className='form-control' placeholder="Пароль" id='password' autoComplete="off" {...register("password", { required: { value: true, message: "Поле \"Пароль\" не может быть пустым" } })} />
                                    {errors.password && <span className='text-danger'>{errors.password?.message}</span>}
                                </div>
                                <input className="btn btn-primary btn-block mb-4 w-100" type="submit" value={'Войти'} />
                            </form>
                        </Col>
                    </Row>
                </CardBody>
                }
        </div>
    );
}

export default TestLoginForm;